import { DemoOverlay } from './types';

export const STORAGE_KEY = 'cheereval:demo:v1';

export function emptyOverlay(): DemoOverlay {
  return {
    userAddedAthlete: null,
    athleteOverlays: {},
    tabbedAthletesOverride: null,
    coachNameOverride: null,
  };
}

export function loadOverlay(): DemoOverlay {
  if (typeof window === 'undefined' || !window.localStorage) return emptyOverlay();
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return emptyOverlay();
    const parsed = JSON.parse(raw) as Partial<DemoOverlay>;
    return {
      userAddedAthlete: parsed.userAddedAthlete ?? null,
      athleteOverlays: parsed.athleteOverlays ?? {},
      tabbedAthletesOverride: Array.isArray(parsed.tabbedAthletesOverride) ? parsed.tabbedAthletesOverride : null,
      coachNameOverride: typeof parsed.coachNameOverride === 'string' ? parsed.coachNameOverride : null,
    };
  } catch {
    return emptyOverlay();
  }
}

export function saveOverlay(overlay: DemoOverlay): void {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(overlay));
  } catch {
    // Quota exceeded or storage disabled — ignore; demo continues in memory only.
  }
}

export function clearOverlay(): void {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
